"use client";

import { ArrowRight, Check, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServingTheTriangle() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const serviceAreas = [{
    name: "Durham, NC",
    href: "/PestControlInDurhamNCPage"
  }, {
    name: "Raleigh, NC",
    href: "/RaleighNCPestControlPage"
  }, {
    name: "Cary, NC",
    href: "/CaryNCPestControlPage"
  }, {
    name: "Chapel Hill, NC",
    href: "/PestControlInChapelHillNCPage"
  }, {
    name: "Wake Forest, NC",
    href: "/PestControlInWakeForestNCPage"
  }, {
    name: "Morrisville, NC",
    href: "/PestControlInMorrisvilleNCPage"
  }, {
    name: "Hillsborough, NC",
    href: "/PestControlInHillsboroughNCPage"
  }];
  const pins = [{
    id: 1,
    top: "32%",
    left: "48%",
    label: "Main Office",
    address: "Durham, NC",
    isHQ: true
  }, {
    id: 2,
    top: "22%",
    left: "62%",
    label: "Wake Forest",
    address: "Service Route",
    isHQ: false
  }, {
    id: 3,
    top: "55%",
    left: "30%",
    label: "Chapel Hill",
    address: "Service Route",
    isHQ: false
  }, {
    id: 4,
    top: "68%",
    left: "58%",
    label: "Raleigh",
    address: "Service Route",
    isHQ: false
  }, {
    id: 5,
    top: "60%",
    left: "48%",
    label: "Cary",
    address: "Service Route",
    isHQ: false
  }, {
    id: 6,
    top: "38%",
    left: "22%",
    label: "Hillsborough",
    address: "Service Route",
    isHQ: false
  }, {
    id: 7,
    top: "48%",
    left: "44%",
    label: "Morrisville",
    address: "Service Route",
    isHQ: false
  }];
  return <section data-section-id="892" id="serving-the-triangle" ref={ref} className="w-full bg-background text-foreground">
      <div className="flex flex-col lg:flex-row w-full">
        {}
        <div className="relative w-full lg:w-3/5 h-[300px] sm:h-[420px] lg:h-[720px] overflow-hidden bg-[hsl(220,15%,6%)]">
          {}
          <div className="absolute inset-0 bg-gradient-to-br from-[hsl(220,15%,8%)] via-[hsl(220,15%,6%)] to-[hsl(220,15%,4%)]" />

          {}
          <svg className="absolute inset-0 w-full h-full opacity-[0.12]" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <defs>
              <pattern id="bp-grid-small" width="24" height="24" patternUnits="userSpaceOnUse">
                <path d="M 24 0 L 0 0 0 24" fill="none" stroke="hsl(45, 50%, 55%)" strokeWidth="0.4" />
              </pattern>
              <pattern id="bp-grid-large" width="120" height="120" patternUnits="userSpaceOnUse">
                <path d="M 120 0 L 0 0 0 120" fill="none" stroke="hsl(45, 50%, 55%)" strokeWidth="0.8" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#bp-grid-small)" />
            <rect width="100%" height="100%" fill="url(#bp-grid-large)" />
          </svg>

          {}
          <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1000 700" preserveAspectRatio="none" aria-hidden="true">
            <path d="M 120 180 L 380 120 L 620 160 L 820 240 L 880 420 L 760 580 L 480 620 L 220 540 L 100 380 Z" fill="hsl(45, 50%, 55%)" fillOpacity="0.05" stroke="hsl(45, 50%, 55%)" strokeWidth="1.2" strokeDasharray="6 6" />
            <path d="M 280 220 L 520 200 L 680 320 L 600 480 L 380 460 Z" fill="none" stroke="hsl(45, 50%, 55%)" strokeWidth="1" strokeDasharray="4 8" strokeOpacity="0.6" />
            <path d="M 180 340 Q 420 280 720 380" fill="none" stroke="hsl(45, 50%, 55%)" strokeWidth="0.8" strokeOpacity="0.4" />
            <path d="M 280 540 Q 500 600 760 500" fill="none" stroke="hsl(45, 50%, 55%)" strokeWidth="0.8" strokeOpacity="0.4" />
          </svg>

          {}
          <div className="absolute top-6 left-6 text-[hsl(45,50%,55%)]/60 font-mono text-xs tracking-widest">
            <div>N 35°59'41"</div>
            <div className="mt-1">W 78°53'56"</div>
          </div>

          <div className="absolute bottom-6 left-6 text-[hsl(45,50%,55%)]/40 font-mono text-[10px] tracking-[0.2em] uppercase">
            Defense Perimeter Map
          </div>

          <div className="absolute bottom-6 right-6 text-[hsl(45,50%,55%)]/40 font-mono text-[10px] tracking-[0.2em]">
            PRECISION SCALE 1:50,000
          </div>

          {}
          {pins.map((pin, i) => <div key={pin.id} data-index={i} className="absolute group" style={{
          top: pin.top,
          left: pin.left,
          transform: "translate(-50%, -100%)"
        }}>
              {}
              <span className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2 block rounded-md" style={{
            width: pin.isHQ ? "48px" : "32px",
            height: pin.isHQ ? "48px" : "32px",
            background: "hsl(45, 50%, 55%)",
            opacity: 0.25,
            animation: `wwb-pulse 4s ease-out infinite`,
            animationDelay: `${i * 0.6}s`
          }} />
              <span className="absolute left-1/2 top-full -translate-x-1/2 -translate-y-1/2 block rounded-md" style={{
            width: pin.isHQ ? "24px" : "16px",
            height: pin.isHQ ? "24px" : "16px",
            background: "hsl(45, 50%, 55%)",
            opacity: 0.4,
            animation: `wwb-pulse 4s ease-out infinite`,
            animationDelay: `${i * 0.6 + 0.3}s`
          }} />

              {}
              <div className="relative z-10 flex flex-col items-center cursor-pointer">
                <MapPin className="text-[hsl(45,50%,55%)] drop-shadow-md" fill="hsl(45, 50%, 55%)" strokeWidth={1.5} style={{
              width: pin.isHQ ? "28px" : "18px",
              height: pin.isHQ ? "28px" : "18px"
            }} />
                {pin.isHQ && <span className="mt-0.5 font-mono text-[9px] tracking-[0.2em] uppercase text-[hsl(0,0%,98%)]/80">
                    HQ
                  </span>}

                {}
                <div className="pointer-events-none absolute bottom-full mb-3 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap">
                  <div className="bg-[hsl(0,0%,98%)] text-[hsl(220,15%,6%)] px-3 py-2 shadow-lg border-l-2 border-[hsl(45,50%,55%)] rounded-md">
                    <div className="font-semibold text-xs font-default">{pin.label}</div>
                    <div className="font-mono text-[10px] text-[hsl(220,10%,45%)] mt-0.5">
                      {pin.address}
                    </div>
                  </div>
                </div>
              </div>
            </div>)}

          <style>{`
            @keyframes wwb-pulse {
              0% { transform: translate(-50%, -50%) scale(0.4); opacity: 0.6; }
              70% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
              100% { transform: translate(-50%, -50%) scale(2.4); opacity: 0; }
            }
          `}</style>
        </div>

        {}
        <div className="w-full lg:w-2/5 bg-card flex items-center">
          <div className={`w-full px-4 py-8 sm:px-8 sm:py-12 lg:px-20 lg:py-20 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <span className="font-mono text-xs tracking-[0.25em] text-primary">06</span>
              <span className="h-px w-8 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] uppercase text-foreground/70">
                Service Coverage
              </span>
            </div>

            {}
            <h2 className="font-default font-semibold text-foreground leading-[1.1] tracking-tight text-2xl sm:text-3xl lg:text-[2.5rem]">
              Defending the <span className="font-serif italic text-primary">Triangle</span> and surrounding areas.
            </h2>

            {}
            <p className="mt-6 text-base leading-relaxed text-muted-foreground font-default max-w-md">
              From the historic streets of Durham to the growing communities of Wake Forest, 
              Attic to Basement provides elite pest defense for every corner of your property.
            </p>

            {}
            <ul className="mt-8 space-y-3">
              {serviceAreas.map((area, i) => <li key={area.name} data-index={i}>
                  <Link to={area.href} className="flex items-center gap-4 group transition-colors duration-200">
                    <span className="flex items-center justify-center w-6 h-6 border border-border bg-background rounded-md transition-colors group-hover:border-primary">
                      <Check className="w-3.5 h-3.5 text-primary" strokeWidth={2.5} />
                    </span>
                    <span className="font-default text-foreground text-base sm:text-lg tracking-tight transition-colors group-hover:text-primary">
                      {area.name}
                    </span>
                    <span className="flex-1 h-px bg-border/60 ml-2" />
                    <span className="font-mono text-[10px] text-muted-foreground tracking-widest transition-colors group-hover:text-primary">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                  </Link>
                </li>)}
            </ul>

            {}
            <div className="mt-12 pt-8 border-t border-border">
              <Link to="/ContactPage" className="inline-flex items-center gap-3 text-foreground hover:text-primary transition-colors duration-200 group">
                <span className="font-default text-base font-medium tracking-tight">
                  Outside these zones? Request a quote.
                </span>
                <ArrowRight className="w-4 h-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}